import isEmpty from 'lodash/isEmpty';

/* 
 * Set the Query Params, or Widget Params fields and get it svalues
 * @autofill fields
 */
export default function setParamFieldValues () {
    const qparams = this.env.appStore.params;
    if (isEmpty(qparams)) return;
    this.paramFieldValues = {};
    const acceptedKeys = {
        'email': 'email',
        'mobilenumber': 'mobile',
    };
    for (let key in acceptedKeys) {
        const fieldName = acceptedKeys[key];
        const value = qparams[key];
        if (!isEmpty(value)) {
            this.paramFieldValues[fieldName] = value;
        }
    }

}